import instance from "http/Manager";
import { headers } from "http/Settings";

export const get_site_data = (id) => {
  return instance.get(`/v1/mngr/site-data/${id}`, { headers });
};

export const post_site_data = (data) => {
  return instance.post(`/v1/mngr/site-data`, data, { headers });
};

export const post_site_image = (data) => {
  return instance.post(`/v1/mngr/site-image`, data, {
    headers: { ...headers, "Content-Type": "multipart/form-data" },
  });
};

export const put_site_data = (data) => {
  return instance.put(`/v1/mngr/site-data`, data, { headers });
};

export const delete_site_data = (id) => {
  return instance.delete(`/v1/mngr/site-data/${id}`, { headers });
};
